import React from "react";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { PageContent } from "../../components/PageContent/PageContent";
import { Button, Divider, Text, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Card } from "../../components/Card/Card";

export const Dashboard = () => {
  return (
    <>
      <PageHeading>
        <PageHeading.Title>Home</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <VStack alignItems="flex-start" width="100%">
          <Text fontSize="lg">
            <b>Data API</b>
          </Text>
          <Divider />
          <Text>
            CherryHub system admin endpoints. Not for public consumption.
          </Text>
          <Button
            as={Link}
            to="/data-api/sysadmin/environment"
            colorScheme="cherryButton"
          >
            Go to Data Api
          </Button>
          <br />
          <Text fontSize="lg">
            <b>Admin</b>
          </Text>
          <Divider />
          <Text>
            Provides Integration/Application configuration for the CherryHub
            platform, and other methods.
          </Text>
          <Button as={Link} to="/admin/businesses" colorScheme="cherryButton">
            Go to Admin
          </Button>
        </VStack>
      </PageContent>
    </>
  );
};
